import { Tooltip, Box } from "@mui/material";
import { FC } from "react";
import { LoadingButton } from "src/shared/components";
import { Can } from "src/shared/lib/rback/Can";

interface IExportStates {
  handleExportDraftReport?: () => void;
  isExporting?: boolean;
  isSavingAll?: boolean;
  hasChanges?: boolean;
  isBonusesCalculated?: boolean;
}

interface IExtraExportButtonProps {
  exportStates: IExportStates;
}

export const ExtraExportButton: FC<IExtraExportButtonProps> = ({
  exportStates,
}) => {
  const {
    handleExportDraftReport,
    isExporting,
    isSavingAll,
    hasChanges,
    isBonusesCalculated,
  } = exportStates;

  return (
    <Tooltip
      title={hasChanges ? "Сохраните внесенные корректировки" : ""}
      disableHoverListener={!hasChanges}
    >
      <Box component="span" sx={{ display: "inline-flex" }}>
        <Can perform="partners.draft-report.export">
          <LoadingButton
            variant="contained"
            onClick={handleExportDraftReport}
            isLoading={isSavingAll}
            disabled={
              hasChanges || isSavingAll || !isBonusesCalculated || isExporting
            }
          >
            Экспорт отчета
          </LoadingButton>
        </Can>
      </Box>
    </Tooltip>
  );
};
